import React from 'react';

const DIRECTIONS = [
  { value: '', label: 'All' },
  { value: 'bullish', label: 'Bullish' },
  { value: 'bearish', label: 'Bearish' },
  { value: 'neutral', label: 'Neutral' },
];

const PLATFORMS = [
  { value: '', label: 'All Platforms' },
  { value: 'twitter', label: 'Twitter' },
  { value: 'youtube', label: 'YouTube' },
  { value: 'substack', label: 'Substack' },
  { value: 'reddit', label: 'Reddit' },
  { value: 'podcast', label: 'Podcast' },
];

const SORT_OPTIONS = [
  { value: '-published_at', label: 'Newest' },
  { value: 'published_at', label: 'Oldest' },
  { value: '-current_return_pct', label: 'Highest Return' },
  { value: 'current_return_pct', label: 'Lowest Return' },
];

export default function PredictionFilters({ filters, onChange }) {
  const { direction, platform, ordering } = filters;

  return (
    <div className="flex flex-wrap items-center gap-3">
      {/* Direction tabs */}
      <div className="flex items-center gap-1 bg-gray-100 rounded-lg p-1">
        {DIRECTIONS.map((d) => (
          <button
            key={d.value}
            onClick={() => onChange({ ...filters, direction: d.value })}
            className={`px-3 py-1.5 rounded-md text-xs font-semibold transition-all ${
              direction === d.value
                ? 'bg-white text-emerald-700 shadow-sm ring-1 ring-emerald-200'
                : 'text-gray-500 hover:text-gray-700'
            }`}
          >
            {d.label}
          </button>
        ))}
      </div>

      {/* Platform select */}
      <select
        value={platform}
        onChange={(e) => onChange({ ...filters, platform: e.target.value })}
        className="text-xs border border-gray-200 rounded-lg px-3 py-2 bg-white text-gray-600 focus:outline-none focus:ring-2 focus:ring-gray-300"
      >
        {PLATFORMS.map((p) => (
          <option key={p.value} value={p.value}>{p.label}</option>
        ))}
      </select>

      {/* Sort */}
      <select
        value={ordering}
        onChange={(e) => onChange({ ...filters, ordering: e.target.value })}
        className="text-xs border border-gray-200 rounded-lg px-3 py-2 bg-white text-gray-600 focus:outline-none focus:ring-2 focus:ring-gray-300"
      >
        {SORT_OPTIONS.map((s) => (
          <option key={s.value} value={s.value}>{s.label}</option>
        ))}
      </select>
    </div>
  );
}
